module.exports = __webpack_public_path__ + "img/01_Screenshot 2025-06-13 at 13.57.08.51a18c1f.jpg";